module.exports = __webpack_public_path__ + "img/bgV2.49bd05e9.png";